import { useEffect, useState } from "react";
import { Calendar, ChevronDown, ChevronUp, Code, Send, X } from "react-feather";
import styles from "./dashboard.module.css";
import Helmet from "react-helmet";
import Footer from "../../../components/Footer";
import { FormControl, InputLabel, MenuItem, Select, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Checkbox, Dialog, DialogTitle, DialogContent, DialogActions, Button, TablePagination } from "@mui/material";
import { Link, useHistory } from "react-router-dom";
import DatePicker from 'rsuite/DatePicker';
import 'rsuite/DatePicker/styles/index.css';
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import Loader from "../../../components/Loader";
import axios from "axios";
import { toast } from 'react-smart-toaster';
import { DashCardLoaderSmall, DashCardLoaderSmall2, TableLoaderSmall2 } from "../../../components/LoaderC";
import dayjs from "dayjs";
import RenewalForm from "./RenewalForm";

function LeaseRenewalDashboard() {
    const redirect = useHistory();
    const { getAccessTokenSilently } = useAuth0();
    const [loading, setLoading] = useState(false);
    const [contentLoading, setContentLoading] = useState(true);
    const [tenantAllList, setTenantAllList] = useState([]);
    const [tenantList, setTenantList] = useState([]);
    const [selectedTenants, setSelectedTenants] = useState([]);
    const [filterData, setFilterData] = useState('');
    const [successModal, setSuccessModal] = useState(false);
    const [successTenants, setSuccessTenants] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [page, setPage] = useState(0);
    const [propertyList, setPropertyList] = useState([]);
    const [selectedProperty, setSelectedProperty] = useState('');
    const [widgetLoading, setWidgetLoading] = useState(true);
    const [widgetData, setWidgetData] = useState(null);
    const [sortKey, setSortKey] = useState('');
    const [sortOrder, setSortOrder] = useState('');
    const [openRenewalFormModal, setOpenRenewalFormModal] = useState(false);


    useEffect(() => {
        async function fetchData() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            await axios.get(process.env.REACT_APP_PAYMENT_API_URL + "v1/lease-renewal/get-all-properties", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                let propertyListTemp = response.data.data;
                propertyListTemp = [{ value: 0, label: "All" }].concat(propertyListTemp);
                setPropertyList(propertyListTemp);
                setSelectedProperty(0);
            }).catch((error) => {
                setPropertyList([]);
            });
        }
        fetchData();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        async function fetchData() {
            setWidgetLoading(true);
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            let params = {};

            if (selectedProperty) {
                params = { property_id: selectedProperty };
            }

            await axios.get(process.env.REACT_APP_PAYMENT_API_URL + "v1/lease-renewal/dashboard/widget-data", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: params
            }).then((response) => {
                setWidgetLoading(false);
                setWidgetData(response.data.data);
            }).catch((error) => {
                setWidgetLoading(false);
                setWidgetData(null);
            });
        }
        fetchData();
    }, [getAccessTokenSilently, selectedProperty]);

    useEffect(() => {
        const fetchTenants = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/lease-renewal/dashboard/tenant-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setContentLoading(false);
                setTenantAllList(response.data.data);
            }).catch((error) => {
                setContentLoading(false);
            });
        }
        fetchTenants();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        let fileredDataTemp = [...tenantAllList];

        if (selectedProperty !== '' && selectedProperty !== 0) {
            fileredDataTemp = fileredDataTemp?.filter(i => i?.property_id === selectedProperty);
        }

        if (filterData === '30 Days') {
            fileredDataTemp = fileredDataTemp?.filter(i => i?.lease_remaining <= 30);
        }

        if (filterData === '60 Days') {
            fileredDataTemp = fileredDataTemp?.filter(i => i?.lease_remaining > 30 && i?.lease_remaining <= 60);
        }

        if (filterData === '90 Days') {
            fileredDataTemp = fileredDataTemp?.filter(i => i?.lease_remaining > 60 && i?.lease_remaining <= 90);
        }

        if (filterData === '120 Days') {
            fileredDataTemp = fileredDataTemp?.filter(i => i?.lease_remaining > 90 && i?.lease_remaining <= 120);
        }

        if (sortKey === 'lease_remaining') {
            fileredDataTemp.sort((a, b) => {
                return sortOrder === 'asc' ? a.lease_remaining - b.lease_remaining : b.lease_remaining - a.lease_remaining;
            });
        }

        if (sortKey === 'tenant_name') {
            fileredDataTemp.sort((a, b) => {
                return sortOrder === 'asc' ? String(a.tenant_name).localeCompare(String(b.tenant_name)) : String(b.tenant_name).localeCompare(String(a.tenant_name));
            });
        }

        if (sortKey === 'property_name') {
            fileredDataTemp.sort((a, b) => {
                return sortOrder === 'asc' ? String(a.property_name).localeCompare(String(b.property_name)) : String(b.property_name).localeCompare(String(a.property_name));
            });
        }

        if (sortKey === 'apt_name') {
            fileredDataTemp.sort((a, b) => {
                return sortOrder === 'asc' ? String(a.apt_name).localeCompare(String(b.apt_name)) : String(b.apt_name).localeCompare(String(a.apt_name));
            });
        }

        if (sortKey === 'lease_end_date') {
            fileredDataTemp.sort((a, b) => {
                return sortOrder === 'asc' ? dayjs(a.lease_end_date).valueOf() - dayjs(b.lease_end_date).valueOf() : dayjs(b.lease_end_date).valueOf() - dayjs(a.lease_end_date).valueOf();
            });
        }

        if (!sortKey) {
            fileredDataTemp.sort((a, b) => a.lease_remaining - b.lease_remaining);
        }


        setTenantList(fileredDataTemp);
    }, [tenantAllList, filterData, selectedProperty, sortKey, sortOrder]);

    const sendMessageBefore = async () => {
        if (selectedTenants.length === 0) {
            toast.error('Please select tenant(s) first');
            return false;
        }

        setLoading(true);

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.post(process.env.REACT_APP_PAYMENT_API_URL + 'v1/lease-renewal/send-message', { tenant_ids: selectedTenants }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setLoading(false);

            setSuccessTenants(response.data.data);

            setSuccessModal(true);

            setTenantAllList(prev => {
                return prev?.map(i => {
                    if (selectedTenants.indexOf(i?.id) > -1) {
                        return { ...i, current_status: 1 };
                    }
                    return i;
                })
            })

            setSelectedTenants([]);
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const sendMessage = async (data) => {
        if (selectedTenants.length === 0) {
            toast.error('Please select tenant(s) first');
            return false;
        }

        setOpenRenewalFormModal(false);
        setLoading(true);

        let newData = { ...data, tenant_ids: selectedTenants }

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.post(process.env.REACT_APP_PAYMENT_API_URL + 'v1/lease-renewal/send-message', newData, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setLoading(false);

            setSuccessTenants(response.data.data);

            setSuccessModal(true);

            setTenantAllList(prev => {
                return prev?.map(i => {
                    if (selectedTenants.indexOf(i?.id) > -1) {
                        return { ...i, current_status: 1 };
                    }
                    return i;
                })
            })

            setSelectedTenants([]);
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const changeSortOrder = (type) => {
        if (type === sortKey) {
            if (sortOrder === "asc") {
                setSortOrder("desc");
            } else {
                setSortOrder("asc");
            }
        } else {
            setSortOrder("asc");
        }
        setSortKey(type);
    }

    return (<>
        {loading && <Loader />}

        <Helmet title="Lease Renewal Dashboard" />

        <div className={`${styles.mainCard}`}>

            <div className={`${styles.pageTitleWrap}`}>
                <Typography display="inline" className={`${styles.pageTitle}`}>Lease Renewal Dashboard</Typography>
            </div>

            <div className={`${styles.CenterBlockSec}`}>
                <div className={`${styles.Row}`}>

                    <div className={`${styles.DahhboardHead}`}>
                        <div className={`${styles.SwitchDiv} ${styles.Select}`}>
                            <div className={`${styles.FormGroupSelect} FormGroup`}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">All Properties*</InputLabel>
                                    <Select labelId="demo-simple-select-label" id="demo-simple-select" label="All Properties" value={selectedProperty} onChange={(e) => setSelectedProperty(e?.target?.value)}>
                                        {propertyList?.map(item => {
                                            return (<MenuItem key={item?.value} value={item?.value}> {item?.label} </MenuItem>);
                                        })}
                                    </Select>
                                </FormControl>
                            </div>
                            {/*<div className={`${styles.FormGroupSelect} FormGroup`}>
                                <DatePicker
                                    oneTap
                                    format="MMM yyyy"
                                    placement={"bottomEnd"}
                                    caretAs={Calendar}
                                    defaultValue={new Date()}
                                />
                            </div>*/}
                        </div>
                    </div>

                    <div className={`${styles.CashFlowSec}`}>
                        <div className={`${styles.CashFlowRow}`}>
                            <div className={`${styles.CashFlowCard}`}>
                                {widgetLoading && <DashCardLoaderSmall2 />}
                                {!widgetLoading && <>
                                    <img src="/static/img/Offer-Icon-1.svg" alt="" />
                                    <div className={`${styles.CashFlowCardHead}`}>
                                        <p className={`${styles.CardHeadTitle}`}>Offers Sent</p>
                                        <p className={`${styles.CardHeadAmount}`}>{widgetData?.offer_sent}</p>
                                    </div>
                                </>}
                            </div>
                            <div className={`${styles.CashFlowCard}`}>
                                {widgetLoading && <DashCardLoaderSmall2 />}
                                {!widgetLoading && <>
                                    <img src="/static/img/success-img.svg" alt="" />
                                    <div className={`${styles.CashFlowCardHead}`}>
                                        <p className={`${styles.CardHeadTitle}`}>Accepted</p>
                                        <p className={`${styles.CardHeadAmount}`}>{widgetData?.offer_accept} {widgetData?.offer_sent > 0 && <span className={`${styles.Count}`}>{parseInt((parseInt(widgetData?.offer_accept) / parseInt(widgetData?.offer_sent)) * 100)}%</span>}</p>
                                    </div>
                                </>}
                            </div>
                            <div className={`${styles.CashFlowCard}`}>
                                {widgetLoading && <DashCardLoaderSmall2 />}
                                {!widgetLoading && <>
                                    <img src="/static/img/Offer-Icon-3.svg" alt="" />
                                    <div className={`${styles.CashFlowCardHead}`}>
                                        <p className={`${styles.CardHeadTitle}`}>Pending</p>
                                        <p className={`${styles.CardHeadAmount}`}>{widgetData?.offer_pending}</p>
                                    </div>
                                </>}
                            </div>
                            <div className={`${styles.CashFlowCard}`}>
                                {widgetLoading && <DashCardLoaderSmall2 />}
                                {!widgetLoading && <>
                                    <img src="/static/img/Offer-Icon-4.svg" alt="" />
                                    <div className={`${styles.CashFlowCardHead}`}>
                                        <p className={`${styles.CardHeadTitle}`}>Declined</p>
                                        <p className={`${styles.CardHeadAmount}`}>{widgetData?.offer_decline}</p>
                                    </div>
                                </>}
                            </div>
                            <div className={`${styles.CashFlowCard}`}>
                                {widgetLoading && <DashCardLoaderSmall2 />}
                                {!widgetLoading && <>
                                    <img src="/static/img/Offer-Icon-5.svg" alt="" />
                                    <div className={`${styles.CashFlowCardHead}`}>
                                        <p className={`${styles.CardHeadTitle}`}>Lease Renewal</p>
                                        <p className={`${styles.CardHeadAmount}`}>{widgetData?.lease_renewal}</p>
                                    </div>
                                </>}
                            </div>
                        </div>

                        <div className={`${styles.CashFlowRowTwo}`}>
                            <div className={`${styles.CashFlowCard}`}>
                                {widgetLoading && <DashCardLoaderSmall2 />}
                                {!widgetLoading && <div className={`${styles.CashFlowCardHead}`}>
                                    <p className={`${styles.CardHeadTitle}`}>Renewals in 30 Days</p>
                                    <p className={`${styles.CardHeadAmount}`}>{widgetData?.renewal_30_days} <span className={`${styles.Text}`}>Leases</span></p>
                                </div>}
                            </div>
                            <div className={`${styles.CashFlowCard}`}>
                                {widgetLoading && <DashCardLoaderSmall2 />}
                                {!widgetLoading && <div className={`${styles.CashFlowCardHead}`}>
                                    <p className={`${styles.CardHeadTitle}`}>Renewals in 60 Days</p>
                                    <p className={`${styles.CardHeadAmount}`}>{widgetData?.renewal_60_days} <span className={`${styles.Text}`}>Leases</span></p>
                                </div>}
                            </div>
                            <div className={`${styles.CashFlowCard}`}>
                                {widgetLoading && <DashCardLoaderSmall2 />}
                                {!widgetLoading && <div className={`${styles.CashFlowCardHead}`}>
                                    <p className={`${styles.CardHeadTitle}`}>Renewals in 90 Days</p>
                                    <p className={`${styles.CardHeadAmount}`}>{widgetData?.renewal_90_days} <span className={`${styles.Text}`}>Leases</span></p>
                                </div>}
                            </div>
                        </div>

                        <div className={`${styles.OfferListSec}`}>
                            <div className={`${styles.CashFlowCard}`}>
                                <div className={`${styles.OfferCardHead}`}>
                                    <div className={`${styles.OfferCardHeadTopSec}`}>
                                        <p className={`${styles.CardHeadTitle}`}>Renewals in 30 Days <span>Next 30, 60, and 90 Days</span></p>
                                        <Link className={`${styles.AddNoteBu}`} onClick={(e) => sendMessageBefore()}>
                                            <Send /> <span>Send Renewal</span>
                                        </Link>
                                    </div>
                                    <div className={`${styles.OffersFilterBURow}`}>
                                        <button className={filterData === '' ? `${styles.FilterBU} ${styles.Active}` : `${styles.FilterBU}`} onClick={(e) => setFilterData('')}>All</button>
                                        <button className={filterData === '30 Days' ? `${styles.FilterBU} ${styles.Active}` : `${styles.FilterBU}`} onClick={(e) => setFilterData('30 Days')}>Next 30 Days</button>
                                        <button className={filterData === '60 Days' ? `${styles.FilterBU} ${styles.Active}` : `${styles.FilterBU}`} onClick={(e) => setFilterData('60 Days')}>31 - 60 Days</button>
                                        <button className={filterData === '90 Days' ? `${styles.FilterBU} ${styles.Active}` : `${styles.FilterBU}`} onClick={(e) => setFilterData('90 Days')}>61 - 90 Days</button>
                                        <button className={filterData === '120 Days' ? `${styles.FilterBU} ${styles.Active}` : `${styles.FilterBU}`} onClick={(e) => setFilterData('120 Days')}>91 - 120 Days</button>
                                    </div>
                                </div>
                                <div className={`${styles.OfferTableSec}`}>
                                    {contentLoading && (<div className="Loader TableLoader">
                                        <TableLoaderSmall2 />
                                    </div>)}

                                    {!contentLoading && <TableContainer className={`${styles.TableDiv} CustomTableDiv`}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell className={`${styles.TableHead}`} style={{ width: 220, cursor: 'pointer' }} onClick={(e) => changeSortOrder("tenant_name")}>
                                                        Tenant
                                                        {sortKey === "tenant_name" && sortOrder === "asc" && (<ChevronDown />)}
                                                        {sortKey === "tenant_name" && sortOrder === "desc" && (<ChevronUp />)}
                                                        {sortKey !== "tenant_name" && (<Code className={`${styles.Normal}`} />)}
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableHead}`} style={{ width: 180, cursor: 'pointer' }} onClick={(e) => changeSortOrder("property_name")}>
                                                        Property
                                                        {sortKey === "property_name" && sortOrder === "asc" && (<ChevronDown />)}
                                                        {sortKey === "property_name" && sortOrder === "desc" && (<ChevronUp />)}
                                                        {sortKey !== "property_name" && (<Code className={`${styles.Normal}`} />)}
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableHead}`} style={{ width: 100, cursor: 'pointer' }} onClick={(e) => changeSortOrder("apt_name")}>
                                                        Unit
                                                        {sortKey === "apt_name" && sortOrder === "asc" && (<ChevronDown />)}
                                                        {sortKey === "apt_name" && sortOrder === "desc" && (<ChevronUp />)}
                                                        {sortKey !== "apt_name" && (<Code className={`${styles.Normal}`} />)}
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableHead}`} style={{ width: 150, cursor: 'pointer' }} onClick={(e) => changeSortOrder("lease_end_date")}>
                                                        Lease End Date
                                                        {sortKey === "lease_end_date" && sortOrder === "asc" && (<ChevronDown />)}
                                                        {sortKey === "lease_end_date" && sortOrder === "desc" && (<ChevronUp />)}
                                                        {sortKey !== "lease_end_date" && (<Code className={`${styles.Normal}`} />)}
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableHead}`} style={{ width: 150, cursor: 'pointer' }} onClick={(e) => changeSortOrder("lease_remaining")}>
                                                        Days Remaining
                                                        {sortKey === "lease_remaining" && sortOrder === "asc" && (<ChevronDown />)}
                                                        {sortKey === "lease_remaining" && sortOrder === "desc" && (<ChevronUp />)}
                                                        {sortKey !== "lease_remaining" && (<Code className={`${styles.Normal}`} />)}
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Renewal Intent</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {tenantList?.map((item, index) => {
                                                    return rowsPerPage === -1 || (index >= page * rowsPerPage && index < page * rowsPerPage + rowsPerPage) ? (<TableRow>
                                                        <TableCell className={`${styles.TableBodyText} ${styles.Head} ${styles.Hover}`}>
                                                            <Checkbox
                                                                checked={selectedTenants?.indexOf(parseInt(item?.id)) > -1}
                                                                value={item?.id}
                                                                onChange={(e) => {
                                                                    if (e.target.checked) {
                                                                        if (selectedTenants?.indexOf(parseInt(item?.id)) === -1)
                                                                            setSelectedTenants(prev => {
                                                                                return prev.concat([parseInt(item?.id)]);
                                                                            })
                                                                    } else {
                                                                        setSelectedTenants(prev => {
                                                                            return prev.filter(i => i !== item?.id)
                                                                        })
                                                                    }
                                                                }}
                                                            />
                                                            <div className={`${styles.ProfileImg}`}><img src={item?.tenant_image} alt="" /></div>
                                                            <div className={`${styles.TenantSec}`}>
                                                                <span onClick={(e) => redirect.push("/people/tenants/details/" + item?.id)}>{item?.tenant_name}</span>
                                                                <p>{item?.tenant_phone}</p>
                                                            </div>
                                                        </TableCell>
                                                        <TableCell className={`${styles.TableBodyText}`} >
                                                            {item?.property_name}
                                                        </TableCell>
                                                        <TableCell className={`${styles.TableBodyText}`} >
                                                            {item?.apt_name}
                                                        </TableCell>
                                                        <TableCell className={`${styles.TableBodyText}`} >
                                                            {item?.lease_end_date ? dayjs(item?.lease_end_date).format('MM/DD/YYYY') : ''}
                                                        </TableCell>
                                                        <TableCell className={`${styles.TableBodyText}`} >
                                                            {item?.lease_remaining <= 30 && <span className={`${styles.StatusBadge} ${styles.Red}`}>{item?.lease_remaining} Days</span>}
                                                            {item?.lease_remaining > 30 && item?.lease_remaining <= 60 && <span className={`${styles.StatusBadge} ${styles.Yellow}`}>{item?.lease_remaining} Days</span>}
                                                            {item?.lease_remaining > 60 && <span className={`${styles.StatusBadge} ${styles.Green}`}>{item?.lease_remaining} Days</span>}
                                                        </TableCell>
                                                        <TableCell className={`${styles.TableBodyText}`} >
                                                            {item?.current_status === 0 && <span className={`${styles.StatusBadge}`}>-</span>}
                                                            {item?.current_status === 1 && <span className={`${styles.StatusBadge} ${styles.Blue}`}>Renewal Sent</span>}
                                                            {item?.current_status === 5 && <span className={`${styles.StatusBadge} ${styles.Red}`}>Renewal Declined</span>}
                                                            {item?.current_status === 2 && <span className={`${styles.StatusBadge} ${styles.Purple}`}>Offer Sent</span>}
                                                            {item?.current_status === 3 && <span className={`${styles.StatusBadge} ${styles.Green}`}>Offer Accepted</span>}
                                                            {item?.current_status === 4 && <span className={`${styles.StatusBadge} ${styles.Yellow}`}>Offer Undecided</span>}
                                                        </TableCell>
                                                    </TableRow>) : null;
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>}

                                    {tenantList?.length > 0 && <div className="Pagination TablePaginationNew List">
                                        <TablePagination
                                            count={tenantList?.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onPageChange={(e, p) => setPage(p)}
                                            showFirstButton={true}
                                            showLastButton={true}
                                            rowsPerPageOptions={[
                                                { label: "20", value: 20 },
                                                { label: "50", value: 50 },
                                                { label: "100", value: 100 },
                                                { label: "All", value: -1 },
                                            ]}
                                            onRowsPerPageChange={(e) => { setRowsPerPage(e.target.value); setPage(0); }}
                                            labelRowsPerPage={"Tenants per page:"}
                                        />
                                    </div>}

                                    {!contentLoading && tenantList.length === 0 && (<div className={`${styles.NoDataMain}`}>
                                        <div className={`${styles.NoDataIMG}`}>
                                            <img src="/static/img/no-tenant.png" alt="No Data" />
                                        </div>
                                        <p className={`${styles.NoDataText}`}>Unfortunately!</p>
                                        <p className={`${styles.NoDataTextSub}`}>we couldn't find a tenant at this time.</p>
                                    </div>)}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div >

        <Dialog
            open={successModal}
            fullWidth
            maxWidth="sm"
            onClose={(e) => setSuccessModal(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">
                Messages sent successfully!
                <button onClick={(e) => setSuccessModal(false)}>
                    <X />
                </button>
            </DialogTitle>
            <DialogContent>
                <div className="ModalFormGroup">
                    <p className="PopupBodyText">
                        Renewal offers have been sent to the selected tenants. Renewal offers have been sent to the selected tenants.
                    </p>
                    <p className={`${styles.ListTextPopup}`}>Recipients</p>
                    <ol className={`${styles.ListSecPopup}`}>
                        {successTenants?.map(i => {
                            return <li>{i}</li>
                        })}
                    </ol>
                </div>
            </DialogContent>
            <DialogActions>
                <Button className="AddPopupBU" onClick={(e) => setSuccessModal(false)}>Okay</Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={openRenewalFormModal}
            fullWidth
            maxWidth="sm"
            onClose={(e) => setOpenRenewalFormModal(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp MobileForm"
        >
            <RenewalForm setOpenRenewalFormModal={setOpenRenewalFormModal.bind(this)} sendMessage={sendMessage.bind(this)} />
        </Dialog>

        <Footer />
    </>);
}

export default withAuthenticationRequired(LeaseRenewalDashboard, {
    onRedirecting: () => <Loader />,
});